export default "__VITE_ASSET__ff9232f3__"